<template>
  <b-modal
    :id="id"
    ref="bModal"
    size="xs"
    qa="add-custom-filter-modal"
    modal-class="addCustomFilterModal"
    centered
    ok-only
    :title="$t('component.addFilterModal.title')"
    :ok-title="$t('global.create')"
    ok-variant="-primary btn-sm"
    :ok-disabled="okDisabled"
    @shown="setModalOptions"
    @hide="resetModalOptions"
    @show="onShow"
  >
    <p>{{ $t('component.addFilterModal.info') }}</p>
    <b-form-group :label="$t('component.addFilterModal.label')">
      <vt-input
        id="addCustomFilter"
        v-model="value.label"
        qa="add-custom-filter-modal-input"
        :autofocus="autofocus"
        class="form-control-sm"
        required
        type="text"
        :name="value.label"
        @enter="$emit('ok', value) && hide()"
      />
    </b-form-group>
    <div
      slot="modal-footer"
      class="footer-banner"
      style="width:100%"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            qa="add-custom-filter-modal-cancel"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            qa="add-custom-filter-modal-create"
            :disabled="okDisabled"
            size="sm"
            class="btn--primary"
            @click="$emit('ok', value) && hide()"
          >
            <i
              class="far fa-plus mr-2"
              aria-hidden="true"
            />{{ $t('global.create') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'AddCustomFilterModal',
    props: {
        id: { type: [Number, String] }
    },
    data() {
        return {
            value: this.getInitValue(),
            autofocus: false
        }
    },
    computed: {
        okDisabled() {
            return !this.value.label
        }
    },
    methods: {
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onShow() {
            this.value = this.getInitValue()
        },
        getInitValue() {
            return { label: '' }
        },
        setModalOptions() {
            this.autofocus = true
        },
        resetModalOptions() {
            this.autofocus = false
        }
    }
}

</script>

<style lang="scss">

.addCustomFilterModal .modal-body p{
  text-align: center;
}

</style>
